import React from 'react';

export function useAsyncState<T, K = any>(initialState?: T) {
   const [state, setState] = React.useState(initialState);
   const [loading, setLoading] = React.useState(false);
   const [error, setError] = React.useState<K>();

   return {state, loading, error, setState, setLoading, setError};
}
